export interface PublicEvent {
  id: string;
  title: string;
  event_date: string | null;
  location: string | null;
  image_url: string | null;
  description: string;
}

interface EventRecord {
  id: string | number;
  title: string;
  event_date?: string | null;
  location?: string | null;
  image_url?: string | null;
  image?: string | null;
  description?: string | null;
  is_published: boolean;
}

const baseUrl = import.meta.env.DEV
  ? "/jambushrusti-api"
  : (
      import.meta.env.VITE_API_BASE_URL ||
      "https://api.jambushusti.universal-software.in/api"
    ).replace(/\/$/, "");
const endpoint = `${baseUrl}/jambushrusti/cms/events/`;

export async function fetchPublicEvents(
  signal?: AbortSignal
): Promise<PublicEvent[]> {
  const events: PublicEvent[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await fetch(`${endpoint}?page=${page}`, {
      signal,
      headers: {
        "X-Tenant-ID":
          import.meta.env.VITE_X_TENANTID ||
          "6cf833d7-bf6f-4688-9136-5674d8053b85",
      },
    });
    if (!response.ok) {
      throw new Error("Unable to load events. Please try again.");
    }
    const payload = await response.json();
    const data = payload.data ?? payload;
    const rows: EventRecord[] = Array.isArray(data) ? data : data.results;
    if (!Array.isArray(rows)) {
      throw new Error("The events response could not be read.");
    }

    for (const event of rows) {
      if (event.is_published === true) {
        events.push({
          id: String(event.id),
          title: event.title || "Untitled event",
          event_date: event.event_date || null,
          location: event.location || null,
          image_url: event.image || event.image_url || null,
          description: event.description || "",
        });
      }
    }
    hasNext = Boolean(data.links?.next ?? data.next);
    page += 1;
  }
  return events;
}
